export default {"src":"/_next/static/media/fluent_building-government-20-regular.68abbccf.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};